// extracted by mini-css-extract-plugin
export default {"header":"Artist_header__CR-HQ","letters":"Artist_letters__PZ86Z","banner":"Artist_banner__-IxVr","bannerImage":"Artist_bannerImage__AoCUK","bannerInner":"Artist_bannerInner__RCpKt"};